module.exports = __webpack_public_path__ + "static/media/icPostGoals.5159e4a1.svg";